import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';

// 获取销售线索数据
let getsaleslead = (param) => {
  return Post({
    url: api.home.getsaleslead,
    bodyParam: param,
  });
};

// 获取网站统计数据
let getwebsitestatistics = (param) => {
  return Post({
    url: api.home.getwebsitestatistics,
    bodyParam: param,
  });
};

// 获取服务详情
let getservicedetail = () => {
  return Get({
    url: api.home.getservicedetail,
  });
};

// 未读询盘
let noreplyinqury = (param) => {
  return Post({
    url: api.home.noreplyinqury,
    bodyParam: param,
  });
};

let googleandsocialmedia = () => {
  return Get({
    url: api.home.googleandsocialmedia,
  });
};
let getnoreplyinqury = (param) => {
  return Post({
    url: api.home.getnoreplyinqury,
    bodyParam: param,
  });
};

// 数据汇总
let getdatacollect = (params) => {
  return Post({
    url: api.home.getdatacollect,
    bodyParam: params,
  });
};
// 邮箱
let getAccountMailInfo = (params) => {
  return Post({
    url: api.home.getAccountMailInfo,
    bodyParam: params,
  });
};
let updateMail = (params) => {
  return Post({
    url: api.home.updateMail,
    bodyParam: params,
  });
};
let getEmailsso = (param) => {
  return Get({
    url: api.home.getEmailsso,
    UrlParam: param,
  });
};
let emailvenify = (param) => {
  return Post({
    url: api.home.validEmail,
    bodyParam: param,
  });
};
let getLanguageReport = (param) => {
  return Get({
    url: api.home.languageReport,
    UrlParam: param,
  });
};

// 服务人员信息
let staffInfo = () => {
  return Get({
    url: api.home.staffInfo,
  });
};
let getWechatQrcode = (param) => {
  return Get({
    url: api.home.getWechatQrcode,
    UrlParam: param,
    
  });
};
export default {
  getsaleslead,
  getservicedetail,
  noreplyinqury,
  googleandsocialmedia,
  getnoreplyinqury,
  getwebsitestatistics,
  getdatacollect,
  getEmailsso,
  getAccountMailInfo,
  updateMail,
  emailvenify,
  getLanguageReport,
  staffInfo,
  getWechatQrcode
};
